import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { FppasCreateResponse, FppasHistoryResponse } from '../../types';
import { CreateFPPASPayload } from '../../types/records/fppas';

export const fppasEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'prepaidEngineApi'
  >
) => ({
  getFppasHistory: builder.query<FppasHistoryResponse, string>({
    query: (params) => ({
      url: `prepaid-engine/fppas/history${params}`
    })
  }),
  createFppasRate: builder.mutation<FppasCreateResponse, CreateFPPASPayload>({
    query: (payload) => ({
      url: `prepaid-engine/fppas/configure`,
      body: payload,
      method: 'POST'
    })
  })
});
